import * as PropTypes from 'prop-types';
import { FormattedMessage, FormattedTime } from 'react-intl';

const ImportTime = ({ time, name }) =>
    time && (
        <p>
            <strong>
                <FormattedMessage id={`imports.detail.${name}`} />:{' '}
            </strong>
            <FormattedTime value={time} year="numeric" month="long" day="2-digit" />
        </p>
    );

ImportTime.propTypes = {
    time: PropTypes.instanceOf(Date),
    name: PropTypes.string.isRequired,
};

ImportTime.defaultProps = {
    time: null,
};

export default ImportTime;
